<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',

}
</script>

<style>

/*//控制图标*/
.BMap_cpyCtrl {
  display: none;
}
/*控制文字*/
.anchorBL{
  display: none;

}
</style>
